import { render, staticRenderFns } from "./survey-review.vue?vue&type=template&id=f3593a5c&scoped=true&"
import script from "./survey-review.vue?vue&type=script&lang=js&"
export * from "./survey-review.vue?vue&type=script&lang=js&"
import style0 from "./survey-review.vue?vue&type=style&index=0&id=f3593a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3593a5c",
  null
  
)

component.options.__file = "survey-review.vue"
export default component.exports